import SimpleQuestion from "./SimpleQuestion";
import * as theme from "../theme";
import { getCalculateVerticalIdFromProspectDoc, INSURER } from "../store/businesslogic/hardwiredlogic";
import {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  Fragment,
} from "react";
import debounce from "lodash.debounce";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import { Switch, FormControlLabel, TextField, Box, Typography }  from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Spinner from "react-bootstrap/Spinner";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  getOperationsList,
  getOperationsSelected,
  loadOperations,
  operationSelected,
} from "../store/operations";
import ActionButton from "../general/ActionButton";
import { getProspectDetails } from "../store/quotes";
import {
  getProspectDoc,
  addOperation,
  getIsProspectUpdating,
  manipulateQuestion
} from "../store/qf";
import translations from "../utils/translations";
import { getBrokerInformation } from "../store/broker";
import AsyncSelect from 'react-select/async';
import { FixedSizeList } from 'react-window';
import {
  changeHelpOrTipText,
  getLanguageCode,
  getQFuserMode,
} from "../store/components";


const isRevenueGeneratedInCanadaTxt = "Are all revenues generated from Canada?";

const textToKeyMapping = {
  "Total annual revenues": "totalAnnualRevenues",
  "Last 12 months": "last12Months",
  "Projected 12 months": "projected12Months",
  "Are all revenues generated from Canada?": "areRevenuesFromCanada",
  "% from Canada?": "percentageFromCanada",
  "% from USA": "percentageFromUSA",
  "% from other countries": "percentageFromOtherCountries",
  "Provide a split by type of work": "provideSplitByWork",
  "% residential": "percentageResidential",
  "% commercial": "percentageCommercial",
  "% industrial": "percentageIndustrial",
  "% agricultural": "percentageAgricultural",
  "Revenue Percentage": "revenuePercentage",
  "Split By Work": "splitByWork",
  "": "", // For empty texts
};

const useStyles = makeStyles((theme) => ({
  option: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1),
    backgroundColor: '#fff',
    borderRadius: 4,
    margin: theme.spacing(0.5, 0),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    width:"100%"
  },
  name: {
    fontWeight: 'bold',
    color: theme.palette.text.primary,
  },
  code: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },
}));

const OperationTable = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  qfusermode,
}) => {
  const [showSpinner, setShowSpinner] = useState("none");
  const handleTableBlur = async (e) => {
    console.log("Table1 has been blurred");
  };
  //console.log("showSpinner: ", showSpinner);

  return (
    <>
      <Spinner
        style={{ display: showSpinner }}
        animation="border"
        size="lg"
        variant="dark"
      />
      <OperationTableInput
        node={node}
        handleAnswerChange={handleAnswerChange}
        qfusermode={qfusermode}
        setShowSpinner={setShowSpinner}
        onBlur={(e) => handleTableBlur(e)}
      ></OperationTableInput>
    </>
  );
};

const OperationTableHeaderView = ({
  widthPercentage,
  node,
  styleTD,
  keyIndex,
  languagepreference,
}) => {
  let fontWeight = "";
  let color = styleTD.color;
  if (node.type == "header") {
    fontWeight = "700";
    widthPercentage = "35%";
    color = "white";
  }
  return (
    <td
      key={`${keyIndex}_header`}
      style={{
        ...styleTD,
        textAlign: "left",
        paddingRight: "21px",
        width: widthPercentage,
        color,
      }}
    >
      {typeof node.text === 'object' && node.text !== null
        ? (node.text[languagepreference] || node.text.en || '')
        : (node.text || '')}{" "}
    </td>
  );
};

const GreenSwitch = withStyles({
  switchBase: {
    color: "white",
    "&$checked": {
      color: "white",
    },
    "&$checked + $track": {
      backgroundColor: "#2C9923",
    },
  },
  checked: {},
  track: {},
})(Switch);

const OperationTDCell = ({
  nonEditable,
  node,
  operation,
  selectAllFunc,
  handleBlur,
  operationTable,
  styleTD,
  operations,
  keyIndex,
  idx,
}) => {
  var contentEditable = true;
  if (nonEditable.includes(node.enText) && nonEditable.includes(operation)) {
    contentEditable = false;
    styleTD = { ...styleTD, color: "lightgrey" };
  } else {
    contentEditable = true;
    styleTD = { ...styleTD };
  }
  const tabIndex = (operations.findIndex((x) => operation == x) + 1) * 560;
  // console.log(operation , " : ", tabIndex)
  // console.log(operations)
  const cellValueN = operationTable?.[node.enText]?.[operation];
  // console.log("cellValueN", cellValueN)
  var [cellValue, setcellValue] = useState(
    operationTable?.[node.enText]?.[operation]
  );
  var [currentNumber, setcurrentNumber] = useState(false);
  if (contentEditable) {
    styleTD.backgroundColor = "rgb(214, 218, 231)";
  }
  useEffect(() => {
    // console.log("Running use effect TDCELL lvl")
    // console.log("cellValue ", cellValue)
    // console.log(operationTable?.[node.text]?.[operation])
    if (operationTable?.[node.enText]?.[operation] != cellValue) {
      // console.log(cellValue)
      // console.log(operationTable?.[node.text]?.[operation])
      //console.log(`reassigning value to ${operationTable?.[node.text]?.[operation]} from ${cellValue}`)
      setcellValue(operationTable?.[node.enText]?.[operation]);
    }

    if( currentNumber != false && currentNumber!= operationTable?.[node.enText]?.[operation] ){
      // console.log("Use EFFECT");
      // console.log(currentNumber);
      // console.log(cellValue);
      setcellValue(operationTable?.[node.enText]?.[operation])
    }
    
  }, [operationTable?.[node.enText]?.[operation], cellValue, currentNumber])

  return (
    <td
      style={styleTD}
      contentEditable={contentEditable}
      suppressContentEditableWarning={true}
      // ref={ inputRef }
      tabIndex={tabIndex}
      type="number"
      key={`${keyIndex}_row_${idx}`}
      onBlur={(e) => handleBlur(e, node.enText, operation, idx)}
      onBeforeInput={(e) => {
        if (e.data && !/^[0-9.]$/.test(e.data)) e.preventDefault();
      }}
      onPaste={(e) => {
        e.preventDefault();
        const text = e.clipboardData.getData("text/plain").replace(/[^0-9.]/g, "");
        document.execCommand("insertText", false, text);
      }}
      onInput={(e) => setcurrentNumber(e.target.innerHTML)}
      value={cellValue}
      onClick={(e) => selectAllFunc(e)}
      onFocus={(e) => selectAllFunc(e)}
    >
      {cellValue}
    </td>
  );
};

const ErrorMsgs = ({ operationTable, percentageContraints, operations }) => {
  var [errorArr, seterrorArr] = useState([]);
  var sums = { "Revenue Percentage": {}, "Split By Work": {} };
  let validConstraintGroups = { "Revenue Percentage": false, "Split By Work": false };
  
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  
  // First, determine which constraint groups have valid data
  for (let idx in percentageContraints) {
    let key = idx == 0 ? "Revenue Percentage" : "Split By Work";
    let hasValidFields = false;
    
    for (let metric of percentageContraints[idx]) {
      if (operationTable[metric]) {
        hasValidFields = true;
        break;
      }
    }
    
    validConstraintGroups[key] = hasValidFields;
  }
  
  // Calculate sums only for valid constraint groups
  for (let idx in percentageContraints) {
    let key = idx == 0 ? "Revenue Percentage" : "Split By Work";
    
    // Skip if this constraint group doesn't have valid fields
    if (!validConstraintGroups[key]) continue;
    
    for (let metric of percentageContraints[idx]) {
      for (let operation of operations) {
        if (!sums[key][operation]) {
          sums[key][operation] = 0;
        }
        
        if (!operationTable[metric]) {
          console.log("Unable to find ", metric);
          continue;
        }

        sums[key][operation] += parseFloat(
          String(operationTable[metric]?.[operation] || 0).replace(/,/g, "")
        );
      }
    }
  }
  
  const [showErrors, setshowErrors] = useState(true);
  
  useEffect(() => {
    let tmpErrorArr = [];
    
    for (let key in sums) {
      // Skip validation for constraint groups without valid fields
      if (!validConstraintGroups[key]) continue;
      
      for (let operation_ in sums[key]) {
        // Check if close enough to 100 (handles floating point imprecision)
        if (Math.abs(sums[key][operation_] - 100) > 0.01) {
          // console.log(`${key} from operation ${operation_} must equal 100%: current value ${sums[key][operation_]}`);
          tmpErrorArr.push(
            `${translations[languagepreference][textToKeyMapping[key]]}${
              translations[languagepreference].fromOperations
            } ${operation_}`
          );
        }
      }
    }
    
    seterrorArr(tmpErrorArr);
    setshowErrors(tmpErrorArr.length > 0);
  }, [operationTable]);

  if (showErrors)
    return (
      <div
        style={{
          width: "100%",
          color: theme.COLORS.red_dot,
          paddingLeft: "1vmin",
          paddingTop: "2px",
          fontSize: "1.2vh",
          letterSpacing: 1,
          marginTop: "15px",
        }}
      >
        <div>
          {translations[languagepreference].operationsBreakDown.error} <br />
          {
            translations[languagepreference].operationsBreakDown
              .followingIsEqual
          }{" "}
          <br />
          <br />
        </div>
        <div>
          {errorArr.map((el, index) => {
            return <div key={index}>{el}</div>;
          })}
        </div>
      </div>
    );
  else {
    return <></>;
  }
};

const OperationTableROWview = ({
  widthPercentage,
  node,
  operations,
  operationTable,
  setoperationTable,
  handleBlur,
  keyIndex,
  setnonEditable,
  nonEditable,
  updateTotal,
}) => {
  let style = {
    borderBottom: "dashed",
    borderBottomWidth: "1px",
    borderColor: "lightgrey",
  };

  let styleTD = {
    height: "1.5vmin",
    paddingLeft: "1vmin",
    color: "rgb(102, 102, 102)",
    fontFamily: "GibsonLight",
    fontWeight: "bold",
    letterSpacing: "0.05vmin",
    paddingRight: "21px",
    width: widthPercentage,
    borderRightStyle: "dotted",
    borderRightWidth: "thin",
    textAlign: "center",
  };
  if (node.type == "header") {
    style = { backgroundColor: "rgb(234, 143, 96)", color: "white" };
  }
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  const inputRef = useRef(null);
  var percentageKeys = [
    "% from Canada?",
    "% from other countries",
    "% from USA",
  ];
  var contentEditable = true;
  let selectAllFunc = (e) => {
    var div = e.target;
    var sel, range;
    if (window.getSelection && document.createRange) {
      range = document.createRange();
      range.selectNodeContents(div);
      sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    } else if (document.body.createTextRange) {
      range = document.body.createTextRange();
      range.moveToElementText(div);
      range.select();
    }
  };
  return (
    <tr key={`${keyIndex}_row`} style={style}>
      <OperationTableHeaderView
        node={node}
        widthPercentage={widthPercentage}
        styleTD={styleTD}
        keyIndex={`${keyIndex}_row`}
        languagepreference={languagepreference}
      ></OperationTableHeaderView>

      {operations.map((operation, idx) => {
        if (node.type == "header") {
          return <td key={`${keyIndex}_row_${idx}`}></td>;
        } else if (node.type == "switch") {
          return (
            <td
              key={`${keyIndex}_row_${idx}`}
              style={{ ...styleTD, paddingRight: "0px" }}
            >
              <FormControlLabel
                control={
                  <GreenSwitch
                    size="small"
                    // defaultChecked={
                    //   operationTable[
                    //     translations[languagepreference].areRevenuesFromCanada
                    //   ][operation]
                    // }
                    defaultChecked={operationTable['Are all revenues generated from Canada?'][operation] != "No" }  
                    onChange={async (e) => {
                      let tmpnonEditable = [...nonEditable];
                      if (e.target.checked) {
                        tmpnonEditable.push(operation);
                      } else {
                        tmpnonEditable = tmpnonEditable.filter(
                          (x) => x != operation
                        );
                      }
                      setnonEditable(tmpnonEditable);
                      let tmpObj = structuredClone(operationTable);
                      tmpObj["% from Canada?"][operation] = e.target.checked
                        ? 100
                        : 0;
                      tmpObj["% from other countries"][operation] = 0;
                      tmpObj["% from USA"][operation] = 0;
                      tmpObj["Are all revenues generated from Canada?"][
                        operation
                      ] = e.target.checked ? "Yes" : "No";
                      console.log(tmpObj)
                      updateTotal(tmpObj);
                    }}
                  />
                }
              ></FormControlLabel>
            </td>
          );
        } else {
          return (
            <OperationTDCell
              nonEditable={nonEditable}
              node={node}
              operation={operation}
              selectAllFunc={selectAllFunc}
              handleBlur={handleBlur}
              operationTable={operationTable}
              styleTD={styleTD}
              operations={operations}
              keyIndex={keyIndex}
              idx={idx}
              key={`${keyIndex}_row_${idx}`}
            ></OperationTDCell>
          );
        }
      })}
      <td
        key={`${keyIndex}_row_total`}
        style={{ ...styleTD, borderRightStyle: "none", color: "grey" }}
      >
        {node.type === "header" ? "" : operationTable?.[node.enText]?.["Total"]}{" "}
      </td>
    </tr>
  );
};

// Helper function for locale-aware number parsing
// Handles both French (comma decimal: "1 000,50") and English (period decimal: "1,000.50") formats
const parseLocaleNumber = (str) => {
  if (typeof str === 'number') return str;
  if (!str) return 0;

  // Remove all spaces first (thousands separator in many locales)
  let cleaned = String(str).replace(/\s/g, '');

  // Check if comma or period is the decimal separator
  // French: "1 000,50" → comma is decimal
  // English: "1,000.50" → period is decimal
  const lastComma = cleaned.lastIndexOf(',');
  const lastPeriod = cleaned.lastIndexOf('.');

  if (lastComma > lastPeriod) {
    // Comma comes after period (or no period at all)
    // Need to check if comma is thousands separator or decimal separator
    const digitsAfterComma = cleaned.slice(lastComma + 1).length;

    if (digitsAfterComma === 3) {
      // Exactly 3 digits after comma = thousands separator (English format)
      // "1,005" → remove comma → 1005
      cleaned = cleaned.replace(/,/g, '');
    } else {
      // 1-2 digits after comma = decimal separator (French format)
      // "100,5" or "100,50" → replace comma with period → 100.5
      cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    }
  } else {
    // Period comes after comma or no comma → period is decimal (English)
    // "1,000.50" → remove commas
    cleaned = cleaned.replace(/,/g, '');
  }

  const num = parseFloat(cleaned);
  return isNaN(num) ? 0 : num;
};

// Helper function to format numbers based on language preference (not browser locale)
// This ensures consistent formatting regardless of browser settings
const formatNumber = (num, languagePref) => {
  if (!num && num !== 0) return '';
  const numValue = typeof num === 'string' ? parseLocaleNumber(num) : num;

  // Split into integer and decimal parts
  const parts = numValue.toString().split('.');
  const integerPart = parts[0];
  const decimalPart = parts[1];

  if (languagePref === 'fr') {
    // French format: 299 933,50 (space thousands, comma decimal)
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return decimalPart ? `${formattedInteger},${decimalPart}` : formattedInteger;
  } else {
    // English format: 299,933.50 (comma thousands, period decimal)
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
  }
};

const OperationTableInput = ({
  node,
  handleAnswerChange,
  qfusermode,
  setShowSpinner,
}) => {
  const defaultRowData = [
    { key: "totalAnnualRevenues", type: "header", id: "A" },
    { key: "last12Months", type: "input", id: "401" },
    { key: "projected12Months", type: "input", id: "405" },
    { key: "", type: "header", id: "A" }, // Empty text
    { key: "areRevenuesFromCanada", type: "switch", id: "410" },
    { key: "percentageFromCanada", type: "input", id: "415" },
    { key: "percentageFromUSA", type: "input", id: "420" },
    { key: "percentageFromOtherCountries", type: "input", id: "425" },
    { key: "", type: "header", id: "A" }, // Empty text
    { key: "provideSplitByWork", type: "header", id: "A" },
    {
      key: "percentageResidential",
      type: "input",
      id: "430",
      calculation: "A + B / C",
    },
    { key: "percentageCommercial", type: "input", id: "435" },
    { key: "percentageIndustrial", type: "input", id: "440" },
    { key: "percentageAgricultural", type: "input", id: "450" },
  ];

  const [input, setInput] = useState(
    node.answer ? node.answer : "DEFAULT OPERATION TABLE MANN"
  );
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;

  const intialOperationTableEmpty = {};
  if (!node.answer) {
    node.logic.rowData.forEach((item) => {
      if (item.text) {
        // Extract English text as the stable key for operationTable
        const key = typeof item.text === 'object' && item.text !== null && item.text.en
          ? item.text.en
          : item.text;
        intialOperationTableEmpty[key] = {};
      }
    });
  }

  // Clean up existing answer data that may have "[object Object]" keys
  const cleanupAnswerData = (answer) => {
    if (!answer) return answer;

    const cleaned = {};
    const rowDataMap = {};

    // Create a map of text values to enText
    node.logic.rowData.forEach((item) => {
      if (item.text) {
        const enText = typeof item.text === 'object' && item.text !== null && item.text.en
          ? item.text.en
          : item.text;

        // Map both the string representation and the enText
        rowDataMap[String(item.text)] = enText;
        rowDataMap[enText] = enText;
      }
    });

    // Clean up keys in the answer object
    Object.keys(answer).forEach((key) => {
      // If key is "[object Object]", try to find the correct key
      if (key === "[object Object]") {
        // Skip this corrupted key - we can't reliably recover it
        console.warn('Skipping corrupted key "[object Object]" in operationTable data');
        return;
      }

      // Use the mapped key if available, otherwise use the original key
      const cleanKey = rowDataMap[key] || key;
      cleaned[cleanKey] = answer[key];
    });

    return cleaned;
  };

  // console.log(
  //   "feeling better",
  //   translations[languagepreference].operationsBreakDown.provideSplitByWork
  // );
  const [operationTable, setoperationTable] = useState(
    node.answer ? cleanupAnswerData(node.answer) : intialOperationTableEmpty
  ); //node.answer ? node.answer :
  //console.log("node.logic.rowData", node.logic.rowData);
  const [rowData, setrowData] = useState(() => {
    if (node.logic.rowData) {
      return node.logic.rowData.map((item) => {
        // Handle bilingual text object {en: "...", fr: "..."}
        if (typeof item.text === 'object' && item.text !== null && item.text.en) {
          return {
            ...item,
            enText: item.text.en,
            text: item.text[languagepreference] || item.text.en
          };
        }
        // Handle key-based translation lookup
        if (item.key) {
          return {
            ...item,
            enText: translations["en"].operationsBreakDown[item.key],
            text: translations[languagepreference].operationsBreakDown[item.key] || ""
          };
        }
        // Legacy: string text
        return {
          ...item,
          enText: item.text,
          text: item.text || ""
        };
      });
    } else {
      return defaultRowData.map((item) => ({
        ...item,
        enText: translations["en"].operationsBreakDown[item.key],
        text: item.key
          ? translations[languagepreference].operationsBreakDown[item.key]
          : "",
      }));
    }
  });
  const [displayTable, setDisplayTable] = useState("block");
  const [heavyOperation, setHeavyOperation] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [debouncedValue, setDebouncedValue] = useState('');
  const [keyValue, setKeyValue] = useState(0)
  const dispatch = useDispatch();
  const LanguageCode = "en";
  const isProspectUpdating = useSelector(getIsProspectUpdating);
  //console.log("OperationTableInput: " , isProspectUpdating)
  const selectedOperations = useSelector(getOperationsSelected);
  const operationsList = useSelector(getOperationsList);
  const ProspectDetails = useSelector(getProspectDoc);
  let operationsFromStore = ProspectDetails.answers.operations.list
    .map((x) => x.name?.en)
    .filter((x) => x !== undefined);
  var [operations, setOperations] = useState(operationsFromStore);
  var [operationsLanguage, setOperationsLanguage] = useState();
  const [newOperation, setnewOperation] = useState("");
  const selectableOperations = [...operationsList.filter((x) => x.verticalid == ProspectDetails.answers.selectedverticalid), ...operationsList.filter((x) => x.verticalid != ProspectDetails.answers.selectedverticalid) ];
  const [intialHint, setintialHint] = useState({})
  const brokerage = useSelector(getBrokerInformation);
  const brokerageCode = brokerage?.information?.brokeragecode;
  const noOperations = operations.length == 0;
  useEffect(() => {
    if (node.logic.rowData) {
      const updatedRowData = node.logic.rowData.map((item) => {
        // Handle bilingual text object {en: "...", fr: "..."}
        if (typeof item.text === 'object' && item.text !== null && item.text.en) {
          return {
            ...item,
            enText: item.text.en,
            text: item.text[languagepreference] || item.text.en
          };
        }
        // Legacy: Handle string text with textToKeyMapping
        return {
          ...item,
          enText: item.text,
          text: textToKeyMapping[item.text]
            ? translations[languagepreference].operationsBreakDown[
                textToKeyMapping[item.text]
              ]
            : item.text, // Retain original text if no mapping exists
        };
      });
      setrowData(updatedRowData);
    }

    // if (node.logic.rowData) {
    //   const updatedRowData = node.logic.rowData.map((item) => ({
    //     ...item,
    //     text: textToKeyMapping[item.text]
    //       ? translations[languagepreference].operationsBreakDown[
    //           textToKeyMapping[item.text]
    //         ]
    //       : item.text, // Retain original text if no mapping exists
    //   }));
    //   setrowData(updatedRowData);
    // }
    else {
      setrowData(
        defaultRowData.map((item) => ({
          ...item,
          enText: translations["en"].operationsBreakDown[item.key],
          text: item.key
            ? translations[languagepreference].operationsBreakDown[item.key]
            : "",
        }))
      );
    }
  }, [languagepreference, node.logic.rowData]);

  useEffect(() => {
    dispatch(loadOperations(brokerageCode));
    if(isRevenueGeneratedInCanadaTxt in operationTable){
      const nonEditableInitalOps = Object.keys(operationTable[isRevenueGeneratedInCanadaTxt]).filter(key => operationTable[isRevenueGeneratedInCanadaTxt][key] == "Yes" )
      setnonEditable([...nonEditable, ...nonEditableInitalOps])
    }
    //console.log(operationTable[isRevenueGeneratedInCanadaTxt])
    //console.log(nonEditable)
    setintialHint(node.hint);
  }, []);

  useEffect(() => {
    let operationsEnglish = ProspectDetails.answers.operations.list
      .map((x) => x.name?.en)
      .filter((x) => x !== undefined);
    setOperationsLanguage(
      ProspectDetails.answers.operations.list
        .filter((x) => x.name?.en !== undefined)
        .map((x) => ({
          en: x.name?.en,
          fr: x.name?.fr,
        }))
    );
    const operationsChanged =
      operationsEnglish.length !== operations.length ||
      operationsEnglish.some((op, i) => op !== operations[i]);
    setOperations(operationsEnglish);
    if (operationsChanged) {
      updateTotal();
    }
  }, [ProspectDetails]);

  useEffect(() => {
    if (isProspectUpdating && heavyOperation) {
      setDisplayTable("none");
      setShowSpinner("block");
    } else {
      setDisplayTable("block");
      if (heavyOperation) {
        setHeavyOperation(false);
        setShowSpinner("none");
      }
    }
  }, [isProspectUpdating, heavyOperation]);

  useEffect(() => {
    if (!areOperationsKeys(operationTable, operations) && heavyOperation) {
      let tmpObj = structuredClone(operationTable);
      for (let key in tmpObj) {
        // Check if this row is a header or switch row
        const rowType = rowData.find((x) => x.enText === key)?.type;
        const isHeaderOrSwitch = ["header", "switch"].includes(rowType);
        tmpObj[key][newOperation] = isHeaderOrSwitch ? "" : "0";
      }
      updateTotal(tmpObj);
      return;
    }
  }, [operationTable, heavyOperation, operations]);

  const updateTotalOld = async (tmpObj) => {
    if (!tmpObj) tmpObj = structuredClone(operationTable);
    //JSON.parse(JSON.stringify(operationTable))  // structuredClone(operationTable)
    else tmpObj = structuredClone(tmpObj); //JSON.parse(JSON.stringify(tmpObj))

    for (let key in tmpObj) {
      for (let operation of operations) {
        if (!tmpObj[key][operation]) {
          tmpObj[key][operation] = 0;
        }
      }

      for (let tmpMtr in tmpObj) {
        for (let tmpOpr in tmpObj[tmpMtr]) {
          if (tmpObj[tmpMtr][tmpOpr])
            tmpObj[tmpMtr][tmpOpr] = +tmpObj[tmpMtr][tmpOpr]
              .toString()
              .replace(/,/g, "");
        }
      }

      let total = 0;
      total = Object.keys(tmpObj[key])
        .filter((k) => k != "Total")
        .reduce((s, j) => parseInt(s) + parseInt(tmpObj[key][j]), 0);
      if (key.includes("%")) {
        total = Object.keys(tmpObj[key])
          .filter((k) => k != "Total")
          .reduce(
            (s, k) =>
              parseFloat(s) +
              (parseFloat(tmpObj[key][k]) / 100) * tmpObj["Last 12 months"][k],
            0
          );
        total = ((total / tmpObj["Last 12 months"]["Total"]) * 100).toFixed(2);
      }
      //console.log(`${key}: ${total}`)
      //tmpObj[key]['Total'] = total;
    }
    //console.log("settingOperationTable")
    //console.log(tmpObj)
    // convert all values to formatted strings based on language preference
    for (let tmpMtr in tmpObj) {
      for (let tmpOpr in tmpObj[tmpMtr]) {
        if (!isNaN(tmpObj[tmpMtr][tmpOpr])) {
          tmpObj[tmpMtr][tmpOpr] = formatNumber(tmpObj[tmpMtr][tmpOpr], languagepreference);
        }
      }
    }
    //console.log("TmpObj: ", tmpObj)
    setoperationTable(tmpObj);
    handleAnswerChange(tmpObj);
  };

  // Pure calculation function - performs all table calculations without side effects
  // Extracted from updateTotal to enable synchronous execution inside handleBlur
  const calculateUpdatedTable = (inputObj) => {
    const clonedObj = inputObj || structuredClone(operationTable);

    // All the calculation logic from updateTotal, but WITHOUT the setState/handleAnswerChange calls
    for (const key in clonedObj) {
      const rowType = rowData.find((x) => x.enText === key)?.type;
      const isHeaderOrSwitch = ["header", "switch"].includes(rowType);

      for (const operation of operations) {
        if (clonedObj[key][operation] == undefined) {
          if (isHeaderOrSwitch) {
            clonedObj[key][operation] = "";
          } else {
            clonedObj[key][operation] = 0;
            if (key == isRevenueGeneratedInCanadaTxt) {
              clonedObj[key][operation] = "Yes";
            } else if (key == "% from Canada?") {
              clonedObj[key][operation] = 100;
              setnonEditable((prevState) => [...prevState, operation]);
            }
          }
        }
      }

      // Convert string values to numbers using locale-aware parsing
      for (const metric in clonedObj[key]) {
        if (key == isRevenueGeneratedInCanadaTxt) continue;
        if (isHeaderOrSwitch) continue;
        clonedObj[key][metric] = parseLocaleNumber(clonedObj[key][metric]);
      }

      // Calculate totals (same logic as current updateTotal)
      let total = Object.keys(clonedObj[key])
        .filter((metric) => metric !== "Total")
        .reduce((sum, metric) => sum + parseFloat(clonedObj[key][metric]), 0);

      if (key.includes("%") && clonedObj["Last 12 months"]) {
        total = Object.keys(clonedObj[key])
          .filter((metric) => metric !== "Total")
          .reduce((sum, metric) => {
            const percentValue = parseFloat(clonedObj[key][metric]) || 0;
            const revenueValue = parseLocaleNumber(clonedObj["Last 12 months"]?.[metric]);
            return sum + (percentValue / 100) * revenueValue;
          }, 0);
        const lastTwelveMonthsTotal = parseLocaleNumber(clonedObj["Last 12 months"]?.["Total"]) || 1;
        total = ((total / lastTwelveMonthsTotal) * 100).toFixed(2);
      }

      if (isNaN(total)) total = 0;
      clonedObj[key]["Total"] = total;
      if (["header", "switch"].includes(rowData.find((x) => x.enText === key)?.type)) {
        clonedObj[key]["Total"] = "";
      }
    }

    // Convert numeric values back to formatted strings based on language preference
    for (const metric in clonedObj) {
      if (metric == "Are all revenues generated from Canada?") continue;
      for (const operation in clonedObj[metric]) {
        if (!isNaN(clonedObj[metric][operation])) {
          clonedObj[metric][operation] = formatNumber(clonedObj[metric][operation], languagepreference);
        }
        if (operation == "" || (!operations.includes(operation) && operation != "Total")) {
          delete clonedObj[metric][operation];
        }
      }
    }

    return clonedObj;
  };

  // Simplified updateTotal - now synchronous, just calls calculateUpdatedTable and updates state
  // Used by switch onChange and useEffects
  const updateTotal = (inputObj) => {
    const clonedObj = calculateUpdatedTable(inputObj);
    setoperationTable(clonedObj);
    handleAnswerChange(clonedObj);
  };

  const areOperationsKeys = (dataObject, operationsArray) =>
    operationsArray.every((op) =>
      Object.values(dataObject).every((cat) => op in cat)
    );
  const operationLength = operations.length + 2;
  const widthPercentage = 100 / operationLength + "%";
  const percentageContraints = [
    ["% from Canada?", "% from USA", "% from other countries"],
    ["% residential", "% commerical", "% industrial", "% agricultural"],
  ];

  const handleBlurOld = useCallback(
    debounce(async (event, k1, k2, index) => {
      let amount = Number(event.target.innerHTML.replace(/[^0-9\.]+/g, ""));
      let oldValue = Number(operationTable[k1]?.[k2]?.replace(/[^0-9\.]+/g, "") || 0);
      if (amount == oldValue) {
        return;
      }

      const tmpObj = structuredClone(operationTable);
      const percentageContraint = percentageContraints.find((pc) =>
        pc.includes(k1)
      );
      if (percentageContraint) {
        const siblingKeys = percentageContraint.filter((x) => x !== k1);
        const siblingTotal = siblingKeys.reduce(
          (sum, key) => sum + +tmpObj[key]?.[k2]?.toString().replace(/,/g, ""),
          0
        );
        const maxAllowedValue = 100 - siblingTotal;
        if (maxAllowedValue < amount) {
          amount = parseFloat(maxAllowedValue);
        }
      }

      // Ensure the key exists before setting the value
      if (!tmpObj[k1]) {
        tmpObj[k1] = {};
      }
      tmpObj[k1][k2] = amount;
      updateTotal(tmpObj);
    }, 300),
    [operationTable, percentageContraints]
  );

  // Fixed handleBlur - uses locale-aware parsing, synchronous calculation, and guaranteed save
  const handleBlur = useCallback(
    (event, k1, k2, index) => {
      // Parse the entered value using locale-aware function
      let amount = parseLocaleNumber(event.target.innerHTML);
      if (isNaN(amount)) return; // Early return if invalid

      setoperationTable((prevTable) => {
        // Parse old value using locale-aware function (handles both string and number types)
        let oldValue = parseLocaleNumber(prevTable[k1]?.[k2]);
        if (amount === oldValue) return prevTable; // No change, skip update

        // Create updated object with the new value
        const tmpObj = structuredClone(prevTable);

        // Apply percentage constraints (ensure percentages don't exceed 100%)
        const percentageContraint = percentageContraints.find((pc) => pc.includes(k1));
        if (percentageContraint) {
          const siblingKeys = percentageContraint.filter((x) => x !== k1);
          const siblingTotal = siblingKeys.reduce(
            (sum, key) => sum + parseLocaleNumber(tmpObj[key]?.[k2]),
            0
          );
          const maxAllowedValue = 100 - siblingTotal;
          if (maxAllowedValue < amount) {
            amount = parseFloat(maxAllowedValue);
          }
        }

        if (!tmpObj[k1]) tmpObj[k1] = {};
        tmpObj[k1][k2] = amount;

        // Calculate totals and format - ALL SYNCHRONOUS, NO nested setState
        const calculatedObj = calculateUpdatedTable(tmpObj);

        // Save to Redux synchronously - guaranteed to run before component can unmount
        handleAnswerChange(calculatedObj);

        return calculatedObj;
      });
    },
    [percentageContraints, handleAnswerChange, calculateUpdatedTable]
  );

  let inputDisplay = operations.length > 5 ? "none" : "block";
  const handleChange = (event) => {
    setInput(event.target.value);
  };
  let widthFromLogic = node.logic.width
    ? `${node.logic.width}vw`
    : theme.inputStyle.width;
  var percentageKeys = [
    "% from Canada?",
    "% from other countries",
    "% from USA",
  ];
  const [nonEditable, setnonEditable] = useState([...percentageKeys]);
  let styleTD = {
    height: "1.5vmin",
    paddingLeft: "1vmin",
    color: "rgb(102, 102, 102)",
    fontFamily: "GibsonLight",
    fontWeight: "bold",
    letterSpacing: "0.05vmin",
    paddingRight: "21px",
    width: widthPercentage,
    borderRightStyle: "dotted",
    borderRightWidth: "thin",
    textAlign: "center",
  };
  // const dispatch = useDispatch();
  const classes = useStyles();

  // Handle selection and processing
  const handleSelection = (value) => {
    if (value) {
      // Perform your logic here with the selected option
      // Example processing logic (e.g., API call, state update)
      // Replace with your actual logic
      const processedResult = `Processed: ${value.name[languagepreference]} (IBC: ${value.ibc}, NAICS: ${value.naics})`;
      let newOperation = value.name.en;
      if ( operations.length > 5 || operations.includes(newOperation) ){
            console.log("early return")
            return;
          }
      var txt = "Operation_" + operations.length;
      let selectedOperation = selectableOperations.find(
        (x) => x.name.en == newOperation
      );
      dispatch(addOperation(selectedOperation, "add"));
      setOperations([...operations, newOperation]);
      setnewOperation("");
      setHeavyOperation(true);
      //setOperations([...operations, newOperation]);
      //setInputValue(null);
      setKeyValue((prev) => prev+1)
    }
  };
  const onOptionHover = (data) => {
    let formattedText = `Name: ${data.name.en}\nIBC: ${data.ibc}\nNAICS: ${data.naics}\nDescription\n${data.description.en}`
    let formattedTextfr = `Nom: ${data.name.fr}\nIBC: ${data.ibc}\nNAICS: ${data.naics}\nDescription\n${data.description.fr}`
    //dispatch(changeHelpOrTipText(formattedText));
    dispatch(manipulateQuestion({ node, key: "hint", newValue: {'en': formattedText, 'fr':formattedTextfr} }));
  }
  const onMenuClose = () => {
    dispatch(manipulateQuestion({ node, key: "hint", newValue: intialHint }));
  }
  return (
    <div style={{ display: displayTable, marginBottom: noOperations ? "1vh" : "9vh", width: "100%" }}>
      <div style={{  display: inputDisplay }}>
        <AsyncAutocomplete 
          items={selectableOperations} 
          valueKey="id" 
          labelKey="name" 
          languagePreference={languagepreference} 
          onSelect={handleSelection} 
          onSelectValue={null} // always want to selection to be cleared
          onOptionHover={onOptionHover}
          onMenuClose={onMenuClose}
          placeholder={translations[languagepreference].selectOperations}
        />
      </div>
      <div style={{ margin: noOperations ? "1vh" : "5vh" }}></div>
      <div>
        <table
          translate="no"
          style={{
            borderCollapse: "collapse",
            display: noOperations ? "none" : null
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  ...styleTD,
                  paddingRight: "21px",
                  width: widthPercentage,
                }}
              >
                {" "}
              </th>
              {operations.map((operation, idx) => {
                const displayName = operationsLanguage?.[idx]?.[languagepreference] || operation;
                return (
                <th
                  key={`${idx}_header`}
                  style={{
                    ...styleTD,
                    paddingRight: "21px",
                    width: widthPercentage,
                  }}
                >
                  <div style={{ display: "inline-flex" }}>
                    {displayName}
                    <DeleteIcon
                      style={{ alignSelf: "center" }}
                      onClick={(e) => {
                        setHeavyOperation(true);
                        if (operations.length <= 0) {
                          return;
                        }
                        var newOperations = operations.filter(
                          (oldOperation) => oldOperation != operation
                        );
                        let selectedOperation = selectableOperations.find(
                          (x) => x.name.en == operation
                        );
                        dispatch(addOperation(selectedOperation, "remove"));
                        setOperations(newOperations);
                        let tmpObj = structuredClone(operationTable);
                        for (let key in tmpObj) {
                          delete tmpObj[key][operation];
                        }
                        setoperationTable(tmpObj);
                      }}
                    ></DeleteIcon>
                  </div>
                </th>
                );
              })}
              <th
                style={{
                  ...styleTD,
                  paddingRight: "21px",
                  width: widthPercentage,
                  textAlign: "center",
                  borderRightStyle: "none",
                }}
              >
                {" "}
                Total{" "}
              </th>
            </tr>
          </thead>
          <tbody>
            {rowData.map((x, idx) => (
              <OperationTableROWview
                node={x}
                keyIndex={idx}
                key={`${idx}_keyz`}
                widthPercentage={widthPercentage}
                operations={operations}
                operationsLanguage={operationsLanguage}
                handleBlur={handleBlur}
                operationTable={operationTable}
                rowData={rowData}
                setrowData={setrowData}
                nonEditable={nonEditable}
                setnonEditable={setnonEditable}
                setoperationTable={setoperationTable}
                updateTotal={updateTotal}
              ></OperationTableROWview>
            ))}
          </tbody>
        </table>
      </div>

      <div>
        <ErrorMsgs
          percentageContraints={percentageContraints}
          operationTable={operationTable}
          operations={operations}
        ></ErrorMsgs>
      </div>
    </div>
  );
};

const MenuList = ({ options, children, maxHeight, getValue }) => {
  const [value] = getValue();
  const height = 70;
  const initialOffset = options.indexOf(value) * height || 0; // Fallback to 0 if NaN
  const safeMaxHeight = Number.isFinite(maxHeight) ? maxHeight : 200; // Fallback height
  const calculatedHeight = Math.min(children.length * height, safeMaxHeight); // Dynamic height

  return (
    <FixedSizeList
      height={calculatedHeight}
      itemCount={children.length}
      itemSize={height}
      initialScrollOffset={0}
      width="100%"
    >
      {({ index, style }) => (
        <div style={style}>{children[index]}</div>
      )}
    </FixedSizeList>
  );
};

const CustomOption = ({ innerProps, isFocused, isSelected, data, selectProps }) => {
  // console.log("innerProps", innerProps)
  const { onOptionHover , languagePreference} = selectProps; 
  return (
    <div
      {...innerProps}
      onMouseEnter={() => {
        if (onOptionHover) {
          onOptionHover(data); // Call onOptionHover with the option data
        }
      }}
      className={`custom-option ${isFocused ? 'focused' : ''} ${isSelected ? 'selected' : ''}`}
    >
      <div className="option-codes" style={{'alignItems':'flex-start'}}>
        <span className="option-name">{data.name[languagePreference]}</span>
        <span className="option-code">{data.vertical.name[languagePreference]}</span>
      </div>
      <div className="option-codes">
        <span className="option-code">IBC: {data.ibc}</span>
        <span className="option-code">NAICS: {data.naics}</span>
      </div>
    </div>
  );
};

const AsyncAutocomplete = ({ items, valueKey, labelKey, placeholder = 'Search...', languagePreference, onSelect, onSelectValue, onOptionHover, onMenuClose }) => {
  // Simulate async data fetching with filtering
  const [inputValue, setInputValue] = useState('');
  const [selectedValue, setSelectedValue] = useState(null); 
  const handleInputChange = (newValue) => {
    setInputValue(newValue);
    return newValue;
  };
  const loadOptions = useCallback(
    (inputValue, callback) => {
      const isNumeric = /^\d+$/.test(inputValue);
      const lowerInput = inputValue.toLowerCase();  
      const filteredOptions = !inputValue
          ? items
          : items
              .filter((item) => {
                if (isNumeric) {
                  const ibcMatch = item.ibc.toString().includes(inputValue);
                  const naicsMatch = item.naics && item.naics.toString().includes(inputValue);
                  return ibcMatch || naicsMatch;
                } else {
                  const nameMatch = item[labelKey][languagePreference].toLowerCase().includes(lowerInput);
                  return nameMatch;
                }
              })
              .slice(0, 100) // Limit to 100 results for performance
        callback(filteredOptions);
    },
    [items, valueKey, labelKey]
  );
  return (
    <AsyncSelect
      cacheOptions
      loadOptions={loadOptions}
      defaultOptions={items}
      placeholder={placeholder}
      components={{ MenuList, Option: CustomOption }}
      styles={{
        control: (base) => ({
          ...base,
          width: '100%',
          fontSize: 16,
          height: 'calc(100% * 1.25)',
          minHeight: 'calc(40px * 1.25)',
          
        }),
        menu: (base) => ({
          ...base,
          // width: 300,
        }),
        input: (base) => ({
          ...base,
          height: 'calc(100% * 2.25)',
        })
      }}
      inputValue={inputValue} // Control input value
      onInputChange={handleInputChange} // Handle input changes
      onChange={onSelect}
      isClearable
      isSearchable
      {...(onSelectValue !== undefined ? { value : onSelectValue } : {})}
      onOptionHover={onOptionHover}
      onMenuClose={onMenuClose}
      languagePreference={languagePreference}
    />
  );
};

export default OperationTable;
